module.exports = __webpack_public_path__ + "static/img/1.1a765db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/zh/1.png
// module id = 3ErV
// module chunks = 0